import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { CandidateMatchModel } from "./candidateMatchModel"

@Serializable
export class MatchModel {
  candidates: CandidateMatchModel[] = []

  constructor(
    data: {
      candidates: any[]
    } | null = null,
  ) {
    if (data) {
      this.candidates = data.candidates.map((c) => new CandidateMatchModel(c))
    }
  }
}
